import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Dashboard } from '../../../../../providers/bridge-api/dashboard.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-dashboard-option-save-and-export',
  templateUrl: './dashboard-option-save-and-export.component.html',
  styleUrls: ['./dashboard-option-save-and-export.component.scss'],
  standalone: false,
})
export class DashboardOptionSaveAndExportComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() dashboard: Dashboard;
  @Input() isReadOnly: boolean;

  @Output() saveAsDashboard: EventEmitter<void> = new EventEmitter();
  @Output() exportDashboard: EventEmitter<void> = new EventEmitter();

  constructor() {}
  ngOnInit(): void {}
}
